import { useEffect } from 'react';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { useDispatch } from 'react-redux';
import ListShimmer from '../../admin/pages/PageShimmers/ListShimmer';
import { hideLoader, showLoader } from '../../admin/store/features/loaderSlice';
import CommonLayoutShimmer from '../../admin/pages/PageShimmers/CommonLayoutShimmer';

const Loader = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(showLoader());
    NProgress.start();

    return () => {
      dispatch(hideLoader());
      NProgress.done();
    };
  });

  return (
    <div className="grid min-h-screen animate-pulse place-content-center text-6xl text-white">
      {/* <CommonLayoutShimmer /> */}
    </div>
  );
};

export default Loader;
